import { render, staticRenderFns } from "./fbi.vue?vue&type=template&id=76d929a0&scoped=true&"
import script from "./fbi.vue?vue&type=script&lang=js&"
export * from "./fbi.vue?vue&type=script&lang=js&"
import style0 from "./fbi.vue?vue&type=style&index=0&id=76d929a0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d929a0",
  null
  
)

export default component.exports